var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"follow-wrapper"},[_c('div',{staticClass:"title"}),_c('div',{staticClass:"tip"},[_vm._v("权限受限，请联系工作人员")])])}]

export { render, staticRenderFns }